export default class CustomError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    // Error.captureStackTrace is a non-standard V8 function that creates the stack property on an
    // Error instance.
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}
